<template>
  <LoginLayout>
    <template v-if="!isComplete">
      <div class="title">
        {{ info.title }}
      </div>
      <div class="resg-progress layout flex-center">
        <div
          class="progress-item layout flex-center"
          :class="isNext ? 'next' : 'action'"
        >
          <span class="icon">1</span>
          <span class="content">手机号验证</span>
        </div>
        <div class="cut" :class="isNext ? 'action' : ''"></div>
        <div
          class="progress-item layout flex-center"
          :class="isNext ? 'action' : ''"
        >
          <span class="icon">2</span>
          <span class="content">注册新用户</span>
        </div>
      </div>
      <el-form :model="formObj" ref="form" v-show="!isNext" :rules="rules1">
        <el-form-item prop="phone">
          <el-input
            placeholder="请输入手机号"
            prefix-icon="el-icon-mobile-phone"
            class="input"
            :maxlength="11"
            v-model="formObj.phone"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <div class="layout">
            <el-input
              placeholder="请输入验证码"
              prefix-icon="el-icon-unlock"
              v-model="formObj.code"
              class="flex input"
              :maxlength="6"
            ></el-input>
            <div class="code flex-none"></div>
          </div>
        </el-form-item>
        <el-form-item prop="phoneCode">
          <div class="layout">
            <el-input
              placeholder="请输入手机验证码"
              prefix-icon="el-icon-message"
              v-model="formObj.phoneCode"
              class="input flex"
              :maxlength="6"
            >
              <template slot="suffix">
                <div v-if="!time" class="pointer code-btn" @click="getCode">
                  获取验证码
                </div>
                <div v-else>{{ time }}秒后可获取</div>
              </template>
            </el-input>
            <div class="code flex-none"></div>
          </div>
        </el-form-item>
        <el-form-item>
          <div style="color: #c6c6c6">
            提交即视为同意<a class="link">《服务协议》</a>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" class="btn" @click="next"
            >同意协议并注册</el-button
          >
        </el-form-item>
        <el-form-item class="last layout">
          <router-link class="link" to="/login">使用已有账号登录</router-link>
        </el-form-item>
      </el-form>
      <el-form v-show="isNext" ref="info" :model="formObj" :rules="rules2">
        <el-form-item prop="email">
          <el-input
            placeholder="请输入邮箱地址"
            prefix-icon="el-icon-message"
            class="input"
            v-model="formObj.email"
            :maxlength="100"
          ></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input
            placeholder="请输入密码"
            prefix-icon="el-icon-lock"
            class="input"
            show-password
            v-model="formObj.password"
            :maxlength="20"
          ></el-input>
        </el-form-item>
        <el-form-item prop="realName">
          <el-input
            placeholder="请输入姓名"
            prefix-icon="el-icon-user"
            class="input"
            v-model="formObj.realName"
            :maxlength="10"
          ></el-input>
        </el-form-item>
        <el-form-item prop="seex">
          <el-radio-group v-model="formObj.sex">
            <el-radio name="sex" :label="1">男</el-radio>
            <el-radio name="sex" :label="2">女</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" class="btn" @click="save"
            >同意协议并注册</el-button
          >
        </el-form-item>
      </el-form>
    </template>
    <template v-else>
      <div class="layout flex-center regi-success">
        <img src="@/assets/img/ok.png" alt="ok" />
        <p style="font-size: 14px; color: #595959">恭喜</p>
        <p>您已注册成功</p>
        <el-button class="goto" type="primary" @click="goto"
          >返回登录</el-button
        >
        <p>
          <span style="color: #1890ff">{{ time }}</span
          >秒后自动返回登录
        </p>
      </div>
    </template>
  </LoginLayout>
</template>

<script>
  import LoginLayout from "@/components/login-layout";
  import { RegisterInfo } from "@/utils/config";
  import rigisterService from "@/apis/rigisterService";
  export default {
    data() {
      let phoneValid = (rule, value, callback) => {
        if (!/^1[0-9]{10}/.test(value)) {
          return callback(new Error("请输入正确的手机号"));
        }
        callback();
      };
      let passwordValid = (rule, value, callback) => {
        if (value.length < 6) {
          return callback(new Error("密码长度不少于6位"));
        }
        callback();
      };
      return {
        info: RegisterInfo,
        formObj: {
          sex: 1,
        },
        isNext: false,
        isComplete: false,
        time: 0,
        timer: null,
        rules1: {
          phone: [
            { required: true, message: "请输入手机号", trigger: "blur" },
            { validator: phoneValid, trigger: "blur" },
          ],
          phoneCode: [
            { required: true, message: "请输入验证码", trigger: "blur" },
          ],
        },
        rules2: {
          // email:[{required:true, message:'请输入邮箱',trigger: "blur"}],
          password: [
            { required: true, message: "请输入密码", trigger: "blur" },
            { validator: passwordValid, trigger: "blur" },
          ],
          realName: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        },
      };
    },
    methods: {
      getCode() {
        this.$refs.form.validateField("phone", (valid) => {
          if (!valid) {
            rigisterService.getCode({ phone: this.formObj.phone }).then((res) => {
              // this.formObj.phoneCode = res;
              this.time = 60;
              this.timemove();
            });
          }
        });
      },
      next() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.isNext = true;
          }
        });
      },
      save() {
        this.$refs.info.validate((valid) => {
          if (valid) {
            rigisterService.addUser({ ...this.formObj }).then((res) => {
              this.isComplete = true;
              this.time = 3;
              this.timemove();
            });
          }
        });
      },
      timemove() {
        this.timer = setTimeout(() => {
          if (this.time > 1) {
            this.time--;
            clearTimeout(this.timer);
            this.timemove();
          } else {
            if (!this.isComplete) {
              this.time = 0;
            } else {
              this.goto();
            }
          }
        }, 1000);
      },
      goto() {
        this.$router.push("/login");
      },
    },
    components: {
      LoginLayout,
    },
  };
</script>

<style lang="scss" scoped>
  .resg-progress {
    margin-bottom: 35px;
    .cut {
      height: 1px;
      width: 48px;
      background: #bfbfbf;
      margin: 0 33px;
      &.action {
        background: #1890ff;
      }
    }
    .progress-item {
      color: #bfbfbf;

      .icon {
        display: flex;
        background-color: #f0f0f0;
        margin-right: 10px;
        width: 33px;
        height: 33px;
        border-radius: 50%;
        justify-content: center;
        align-items: center;
      }
      &.next {
        .icon {
          background-color: #ccecff;
          color: #ffffff;
        }
      }
      &.action {
        color: #333333;
        .icon {
          background-color: #1b9aee;
          color: #ffffff;
        }
      }
    }
  }
  .regi-success {
    font-size: 12px;
    flex-direction: column;
    color: #8c8c8c;
    p {
      line-height: 2;
    }
    .goto {
      margin-top: 20px;
      margin-bottom: 10px;
      width: 200px;
    }
  }
  .code-btn {
    color: #1890ff;
  }
  .input {
    line-height: 50px;
    ::v-deep input {
      line-height: 50px;
      height: 50px;
      padding-left: 40px;
    }
    ::v-deep .el-input__prefix {
      font-size: 20px;
    }
  }
  .btn {
    width: 100%;
    height: 50px;
    font-size: 20px;
  }
  .link {
    color: #1890ff;
    text-decoration: none;
  }
  .last {
    justify-content: flex-end;
  }
</style>
